import { Creator } from '../../Creators/creatorTypes';

/**
 * Generate discount code from template by replacing placeholders with creator data
 * 
 * Supported placeholders:
 * - {handle} - Creator's handle (uppercase)
 * - {handle:first:N} - First N characters of handle
 * - {handle:first:N:upper} - First N characters of handle in uppercase
 * - {id} - Creator ID
 * - {name} - Creator shipping name
 * 
 * @example
 * generateCodeName('{handle:first:4:upper}20', creator) => 'GUST20'
 * generateCodeName('SAVE{handle}', creator) => 'SAVEgustavjorneskog'
 */
export const generateCodeName = (template: string, creator: Creator): string => {
  let result = template;
  
  // Get handle from platform data
  let handle = '';
  if (creator.tiktok_data && creator.tiktok_data.length > 0) {
    handle = creator.tiktok_data[0].handle || '';
  } else if (creator.instagram_data && creator.instagram_data.length > 0) {
    handle = creator.instagram_data[0].handle || '';
  } else if (creator.twitch_data && creator.twitch_data.length > 0) {
    handle = creator.twitch_data[0].handle || '';
  }
  
  // Remove @ symbol if present
  handle = handle.replace('@', '');
  
  // If no handle found, use fallback
  if (!handle) {
    handle = 'CREATOR';
  }
  
  // Replace {handle:first:N:upper} or {handle:first:N} patterns
  const handleRegex = /\{handle(?::first:(\d+))?(?::upper)?\}/g;
  result = result.replace(handleRegex, (match, length) => {
    let processedHandle = handle;
    
    // If length is specified, take first N characters
    if (length) {
      processedHandle = processedHandle.substring(0, parseInt(length));
    }
    
    // If :upper is in the match, convert to uppercase
    if (match.includes(':upper')) {
      processedHandle = processedHandle.toUpperCase();
    }
    
    return processedHandle;
  });
  
  // Replace simple {handle} placeholder (fallback for simple cases)
  if (result.includes('{handle}')) {
    result = result.replace('{handle}', handle.toUpperCase());
  }
  
  // Replace {id} placeholder
  if (result.includes('{id}')) {
    result = result.replace('{id}', creator.id || 'UNKNOWN');
  }
  
  // Replace {name} placeholder
  if (result.includes('{name}')) {
    const name = (creator.creator_shipping?.name || 'CREATOR').replace(/\s+/g, '').toUpperCase();
    result = result.replace('{name}', name);
  }
  
  return result;
};

